interface SearchTag {
	value: string;
}

const search: SearchTag[] = [];

export { search };
